module.exports = __webpack_public_path__ + "img/taiyo_cursor.0b8bc8c7.png";